import React, { useState, useEffect } from 'react';
// components
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getAlertLive, getRDPMSHealthLive, getUserRequestAPI } from '../../API/RDPMS_API';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import {
    mapRequestDataToOptions,
    rdpmshealthDetailsColumns,
    rdpmshealthLiveColumns,
    sizePerPageList,
} from './requestDataMapper';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import PieChartComponent from '../../components/Charts/PieChartComponent';

const RDPMSHealthLive = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    const userRole = auth?.user?.role;

    const [summaryData, setSummaryData] = useState([]);
    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const [selectedZones, setSelectedZones] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedDivisions, setSelectedDivisions] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedStation, setSelectedStation] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedAssetsType, setSelectedAssetsType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedViews, setSelectedViews] = useState({ value: 'table', label: 'Table' });

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [assetsTypeCode, setAssetsTypeCode] = useState([]);
    const [assetsType, setAssetsType] = useState([]);
    const [assetsNumber, setAssetsNumber] = useState([]);
    const [statusMessage, setStatusMessage] = useState('');
    const [pieChart, setPieChart] = useState([]);

    useEffect(() => {
        const fetchStation = async () => {
            await getRequestData(auth.user.id);
        };

        fetchStation();
    }, []);

    useEffect(() => {
        if (stations && stations.length > 0) {
            getRDPMSHealthLiveData(limit, pageNumber);
        }
    }, [stations]);

    const { t } = useTranslation();

    // const getRDPMSHealthLiveData = async (limits, pages) => {
    //     Loading();

    //     let limitNumber = limits ? limits : limit;
    //     let pagesNumber = pages ? pages : pageNumber;

    //     const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

    //     const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

    //     let station = [];
    //     if (userRole === 'super admin') {
    //         // Existing logic
    //         station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
    //     } else {
    //         //  user station select
    //         if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
    //             station = selectedStation.map((s) => s.value);
    //         } else {
    //             // not select station select  → get stations state
    //             station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
    //         }
    //     }

    //     const assetsType = selectedAssetsType.some((a) => a.value === 'all')
    //         ? []
    //         : selectedAssetsType.map((a) => a.value);

    //     let request = {
    //         zone: zone,
    //         division: division,
    //         station: station,
    //         asset_type: assetsType,

    //         page_number: pagesNumber,
    //         page_size: limitNumber,
    //     };

    //     let response = await getRDPMSHealthLive(request);
    //     // console.log(response, 'response....');

    //     if (response) {
    //         // ===== Summary Table Data =====
    //         const summaryData = [
    //             {
    //                 srNo: 1,
    //                 totalSensors: response?.summary?.totalSensors,
    //                 faultySensors: response?.summary?.faultySensors,
    //                 totalIoTs: response?.summary?.totalIoTs,
    //                 faultyIoTs: response?.summary?.faultyIoTs,
    //                 totalNetwork: response?.summary?.totalNetwork,
    //                 faultyNetwork: response?.summary?.faultyNetwork,
    //                 totalStationGateway: response?.summary?.totalGateway,
    //                 faultyStationGatway: response?.summary?.faultyGateway,
    //             },
    //         ];

    //         setSummaryData(summaryData); // FE me alag state

    //         // ===== Live Asset Table Data =====
    //         let srNo = (response?.pagination?.currentPage - 1) * limitNumber + 1;

    //         const dataArray = [];
    //         const pieMap = {};

    //         response.zone?.forEach((z) => {
    //             z.division?.forEach((d) => {
    //                 d.station?.forEach((s) => {
    //                     s.asset_type?.forEach((ast) => {
    //                         const key = ast.astc || 'Unknown';
    //                         const faultyCount = (ast.asset_number || []).filter(
    //                             (a) => a.faulty_sensor_description !== '---' || a.faulty_iot_description !== '---'
    //                         ).length;
    //                         pieMap[key] = (pieMap[key] || 0) + faultyCount;

    //                         ast.asset_number?.forEach((asn) => {
    //                             dataArray.push({
    //                                 srNo: srNo++,
    //                                 zoneCode: z.zc || '',
    //                                 divisionCode: d.dc || '',
    //                                 stationCode: s.sc || '',
    //                                 assetType: ast.astc || '',
    //                                 assetNumber: asn.asnc || '',
    //                                 faultySensorDescription: asn.faulty_sensor_description || '---',
    //                                 faultyIotDescription: asn.faulty_iot_description || '---',
    //                                 faultyNetworkDescription: asn.faulty_network_description || '---',
    //                                 faultyStationGateway: asn.faulty_station_gateway || '---',
    //                             });
    //                         });
    //                     });
    //                 });
    //             });
    //         });
    //         setPieChart(Object.keys(pieMap).map((k) => ({ name: k, value: pieMap[k] })));
    //         setPageNumber(response?.pagination?.currentPage);
    //         setPageCount(response?.pagination?.totalPages);
    //         setTotalCount(response?.pagination?.totalCount);

    //         setData(dataArray);

    //         setStatusMessage('RDPMS Health Live details fetched successfully');
    //     }

    //     Loading();
    // };

    const getRDPMSHealthLiveData = async (limits, pages) => {
        Loading();

        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        let station = [];
        if (userRole === 'super admin') {
            station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        } else {
            if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
                station = selectedStation.map((s) => s.value);
            } else {
                station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
            }
        }

        const assetsType = selectedAssetsType.some((a) => a.value === 'all')
            ? []
            : selectedAssetsType.map((a) => a.value);

        let request = {
            zone: zone,
            division: division,
            station: station,
            asset_type: assetsType,

            page_number: pagesNumber,
            page_size: limitNumber,
        };

        let response = await getRDPMSHealthLive(request);

        if (response && response.isSuccess !== false) {
            // ===== Summary Table Data — backend se seedha =====
            const summaryData = [
                {
                    srNo: 1,
                    totalSensors: response?.summary?.totalSensors,
                    faultySensors: response?.summary?.faultySensors,
                    totalIoTs: response?.summary?.totalIoTs,
                    faultyIoTs: response?.summary?.faultyIoTs,
                    totalNetwork: response?.summary?.totalNetwork,
                    faultyNetwork: response?.summary?.faultyNetwork,
                    totalStationGateway: response?.summary?.totalGateway,
                    faultyStationGatway: response?.summary?.faultyGateway,
                },
            ];
            setSummaryData(summaryData);

            // ===== Live Asset Table Data — backend se seedha (tableRows) =====
            setData(response?.tableRows || []);

            // ===== Pie chart — backend se seedha (pieChartRows) =====
            setPieChart(response?.pieChartRows || []);

            setPageNumber(response?.pagination?.currentPage);
            setPageCount(response?.pagination?.totalPages);
            setTotalCount(response?.pagination?.totalCount);

            setStatusMessage('RDPMS Health Live details fetched successfully');
        } else {
            setSummaryData([]);
            setData([]);
            setPieChart([]);
            setStatusMessage('Data fetch failed, please try again');
        }

        Loading();
    };
    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);
            // console.log(response, 'getUserRequestAPI response....');

            if (response) {
                const { stations, zones, divisions, assetsTypeCode, assetsType, assetsNumber } =
                    mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
                setAssetsTypeCode(assetsTypeCode);
                setAssetsType(assetsType);
                setAssetsNumber(assetsNumber);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getRDPMSHealthLiveData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getRDPMSHealthLiveData(limit, value);
    };

    const viewOptions = [
        { label: 'Table', value: 'table' },
        { label: 'Pictorial', value: 'pictorial' },
    ];

    return (
        <>
            <ToastContainer />

            <div className=" py-1 " style={{ width: '100%' }}>
                {/* <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                       
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                RDPMS Health Live
                            </button>
                        </div>
                    </div>
                </div> */}

                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        <div className="col-12 col-md-auto">
                            <h5
                                className="fw-bold mb-1"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#000',
                                    paddingLeft: '10px',
                                }}>
                                RDPMS Health Live
                            </h5>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card my-2 p-1"
                    style={{
                        width: '100%',
                        boxShadow: '0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    {/* sirf container aur spacing update */}
                    <div
                        className="container-fluid"
                        style={{
                            paddingLeft: '10px',
                            paddingRight: '10px',
                        }}>
                        <form>
                            <div className="row d-flex gx-3 gy-2 align-items-baseline">
                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="Assets Type"
                                    id="assetsSelect"
                                    options={assetsType}
                                    selectedValues={selectedAssetsType}
                                    onChange={setSelectedAssetsType}
                                />

                                <MultiSelectDropdown
                                    label="View"
                                    id="viewSelect"
                                    options={viewOptions}
                                    selectedValues={selectedViews}
                                    onChange={setSelectedViews}
                                    isMulti={false}
                                />

                                <div className="col-auto ms-auto d-flex flex-column">
                                    <label style={{ visibility: 'hidden', marginBottom: '0.25rem' }}>Submit</label>
                                    <button
                                        type="button"
                                        className="btn"
                                        onClick={() => getRDPMSHealthLiveData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                {(!selectedViews || selectedViews.value === 'table') && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0  text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <Table columns={rdpmshealthDetailsColumns} data={summaryData} />

                        <Table
                            columns={rdpmshealthLiveColumns}
                            data={data}
                            pageSize={limit}
                            pageCount={pageCount}
                            pageNumber={pageNumber}
                            totalCount={totalCount}
                            sizePerPageList={sizePerPageList}
                            isSortable={true}
                            pagination={true}
                            isSearchable={true}
                            onPageChange={handlePageChange}
                            onPageClick={handlePageClick}
                        />
                    </div>
                )}

                {selectedViews?.value === 'pictorial' && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0  text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <PieChartComponent data={pieChart} />
                    </div>
                )}
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RDPMSHealthLive;
